import { useNavigate } from 'react-router-dom';

const NotFound404Page = () => {
  const navigate = useNavigate();

  return (
    <div>
      페이지가 존재하지 않습니다.
      <button onClick={() => navigate('/login')}>로그인으로 이동</button>
    </div>
  );
};

export default NotFound404Page;
